import { Vue, Prop, Component } from 'vue-property-decorator';
import { State } from '@/store/models';
import { Asset } from '@/store/models/asset';
import WithDownloads from '@/components/wrappers/downloads/WithDownloads.vue';
import FundDocs from '@/components/common/fund-docs/FundDocs.vue';
import { Action, State as ClassState } from 'vuex-class';
import NetValue from '@/components/common/net-value/netValue.vue';

@Component({
  components: {
    WithDownloads,
    FundDocs,
    NetValue,
  },
})

export default class PropertyInfo extends Vue {
  @Prop({ default: (): null => null }) asset!: Asset;
  @Prop({ default: (): boolean => false }) userLoggedIn!: boolean;
  @Action openModal!: Function;
  @ClassState user!: State['user'];

  get assetId(): string {
    return this.$route.params.id;
  }

  get assetAddress(): string {
    return this.asset ? this.asset.city : '';
  }
}
